import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { I18nModule } from '../../../../../core/i18n';
import { CatalogArticleListModule, SearchFieldModule, ShowPerPageModule } from '../../../../../shared';
import { LoadMoreComponent } from '../../../../../shared/components/load-more/load-more.component';
import { NoResultsModule } from '../../../../../shared/components/no-results/no-results.module';
import { MyAssortmentArticleListComponent } from './my-assortment-article-list.component';

@NgModule({
  imports: [
    CommonModule,
    CatalogArticleListModule,
    LoadMoreComponent,
    NoResultsModule,
    I18nModule,
    SearchFieldModule,
    ReactiveFormsModule,
    ShowPerPageModule,
  ],
  declarations: [MyAssortmentArticleListComponent],
  exports: [MyAssortmentArticleListComponent],
})
export class MyAssortmentArticleListModule {}
